import { Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCreateCarrier extends Layout {
    textboxNumber: Textbox;
    textboxTypeOfNumber: Textbox;
}
